import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EastIcon from "@mui/icons-material/East";
import { useLanguage } from "../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
const Wealth = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { language, toggleLanguage, translations } = useLanguage();
  const features = [translations[language]?.weathSetUp, translations[language]?.weathSupport, translations[language]?.weathLiquidity,];

  return (
  <Box sx={{ padding: { xs: " 35px", md: "0rem 5.5rem" }}}>
      <Box sx={{paddingTop:0.1,   borderRadius: "20px",minHeight: "420px", }}>
        <Box
          sx={{
            backgroundImage: "url('Images/wealthback.png')", // ← replace with your image path
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            py: { xs: 2, md: 4 },
            textAlign: "center",
            px: 2,
            borderRadius: "20px",
            color: "#000",
            minHeight: "450px",
            marginBottom: "30px",
            border: {
              xs: "0.2px solid rgba(36, 148, 201, 0.5)", // ❌ No border on small screens
              sm: "0.2px solid rgba(36, 148, 201, 0.5)", // ✅ Border on medium and up
            },
           
            // borderLeft: "0.2px solid rgba(36, 148, 201, 1.5)",
            
          }}
        >
          {/* Logo */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: 2,
                // boxShadow: 3,
                overflow: "hidden",
              }}
            >
              <img
                src="Images/ShadowLogo.png" // ← replace with your logo path
                alt="Logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
          </Box>

          {/* Heading */}
          <Typography
            variant={isMobile ? "h2" : "h2"}
            fontWeight={700}
            sx={{ mb: 3 }}
          >
              {translations[language]?.weathTitle} <br />
              {translations[language]?.weathTitles}
          </Typography>

          {/* Features */}
          <Stack
            direction={isMobile ? "column" : "row"}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 4,mt:6 }}
          >
            {features?.map((text, index) => (
              <Stack
                direction="row"
                spacing={{ xs: 1, sm: 2 }}
                alignItems="center"
                key={index}
              >
                <CheckCircleIcon sx={{ color: "rgba(0, 195, 129, 1)" }} />
                <Typography variant="h5">{text}</Typography>
              </Stack>
            ))}
          </Stack>

          {/* CTA Button */}
          <Button
           onClick={()=> navigate("/partner")}
          disableRipple
            variant="contained"
            sx={{
              backgroundColor: "rgba(25, 171, 226, 1)",
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 400,
              boxShadow: "none",
              px: 4,
              py: 1.5,
              "&:hover": {
                backgroundColor: "rgba(25, 171, 226, 1)",
                boxShadow: "none",
              },
              "&:active": {
                boxShadow: "none", // 🛑 no shadow on click
              },
            }}
          >
           {translations[language]?.weathButton}&nbsp;
            <EastIcon />
          </Button>
        </Box>
      </Box>
</Box>
  );
};

export default Wealth;